// index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter,  } from "react-router-dom";
// Redux imports
import { Provider } from 'react-redux';
import { store } from './redux/store'; // or wherever your store.js is

// Mantine imports
import { MantineProvider } from '@mantine/core';
import { MantineEmotionProvider } from '@mantine/emotion';

import './index.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(

  <Provider store={store}>
    <MantineEmotionProvider>
      <MantineProvider theme={{ /* your theme settings */ }}>
        <BrowserRouter >
          <App />
        </BrowserRouter >
      </MantineProvider>
    </MantineEmotionProvider>
  </Provider>

);
